<template>
    <div>
            <top-navbar></top-navbar>


            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Employee </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/questions/index"> Feedback  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.usertype }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




              
                <b-modal :id="infoModal1.id"
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"

     bottom>
    <template   #modal-title>

      <h3 >Confirm !</h3>



    </template>

    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm ?</h5>
    </div>
    <hr>

    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>


  </b-modal>


            <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                        <tbody >


                          <tr>
                            <td class="width-custom2"><b>Name </b></td>
                           <td>{{ all_data.usertype }}</td>
                          </tr>
                          <tr>
                            <td><b>Email</b></td>
                           <td>{{ all_data.email }}</td>
                          </tr>
                           <tr>
                            <td><b>Phone</b></td>
                           <td>{{ all_data.phone }}</td>
                          </tr>
                          <tr>
                            <td><b>Questionnaire Code</b></td>
                           <td>{{ all_data.relatedToPepar.questionnaire_name }}</td>
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ all_data.relatedToStatus.status }}</td>
                          </tr>

                         
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ all_data.created_date }}</td>
                          </tr>
                         
                        


                        </tbody>


                      </table>

                      </div>
                      </div>



                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Questionnaire</b></h6>

   <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Category</th>
                              <th >Question</th>
                              <th >Remarks</th>
                              <th >Select Choices</th>
                              
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.Category}}</td>
                              <td >{{detail.Question}}</td>
                              <td >{{detail.remark}}</td>
                               <td v-if="detail.multi_choise=='free_text'">{{detail.free_text_result}}</td>
                              <td v-else> <span v-for="(c, index) in detail.choises" :key="index">
                                    <input v-model="c.result" class="custom-checkbox" type="checkbox" disabled> {{ c.label }}<br>
                                    </span>
                                </td>
                             
                             </tr>
                             
                             
                            </tbody>

                          </table>
                        </div>


            </div>
        </div>



<br><br>










                </div>
                </div>
              </div>
            </div>

            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'



      export default {

        mounted(){
    this.loadAlldata()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
            total:{},
            all_data:{},
            category:{},
            isLoading:true,
            brand:{},
            supplier:{},
            status:{},
            user:{},
            all_code:{},
            crm:{},
            // isLoading:true,
            details:[],
            dets:[],
            mservicelogs:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },

        // imageUrl: '/img/evenware-logo.png'

          }

        },
        components :{

            ContentFooter,
            TopNavbar,

        },

        methods : {


       
          async Confirm(id) {


       try {
         const { data} = await  axios.get('/squatation/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();

            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },


    


          async Update(){
        this.$router.push('/quotation/update?id='+this.id);
      },

      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);

      },
         

            async loadAlldata() {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/questions/viewresult?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.all_data = data.all_data;
        
          this.details = data.details;
        //  this.dets = data.dets;

          this.isLoading = false;
      

      } catch (error) {
        console.log(error.response);
      }
    },







    },

    }

    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;



  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
.custom-checkbox:disabled {
  opacity: 1; /* remove greyed look */
}

.custom-checkbox:disabled:checked {
  accent-color: #0d6efd !important; /* Bootstrap blue */
}
.custom-checkbox {
  accent-color: #0d6efd;
}
    </style>
